if (!customElements.get('lusso-before-after')) {
  customElements.define('lusso-before-after', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      this.slides = [...this.querySelectorAll('[data-comparison-block]')];
      this.index = 0;
      this.querySelectorAll('.comparison-range').forEach(input => {
        const frame = input.closest('.comparison-frame');
        const update = () => {
          const value = Math.max(0, Math.min(100, Number(input.value)));
          frame.style.setProperty('--comparison-split', `${value}%`);
          input.setAttribute('aria-valuetext', `${value}% ${input.dataset.beforeLabel}`);
        };
        const move = event => {
          const box = frame.getBoundingClientRect();
          if (!box.width) return;
          input.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX-box.left)/box.width*100))));
          update();
        };
        input.addEventListener('input', update, options);
        input.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          event.preventDefault(); input.focus({preventScroll:true});
          input.setPointerCapture(event.pointerId); move(event);
        }, options);
        input.addEventListener('pointermove', event => {
          if (input.hasPointerCapture(event.pointerId)) move(event);
        }, options);
        input.addEventListener('pointerup', event => {
          if (input.hasPointerCapture(event.pointerId)) input.releasePointerCapture(event.pointerId);
        }, options);
        update();
      });
      this.querySelector('[data-comparison-prev]')?.addEventListener('click', () => this.show(this.index-1), options);
      this.querySelector('[data-comparison-next]')?.addEventListener('click', () => this.show(this.index+1), options);
      this.querySelectorAll('.comparison-frame--combined').forEach(frame => {
        let start;
        frame.addEventListener('dragstart', event => event.preventDefault(), options);
        frame.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          start = {x:event.clientX,y:event.clientY};
          frame.setPointerCapture(event.pointerId);
        }, options);
        frame.addEventListener('pointerup', event => {
          if (!start) return;
          const dx=event.clientX-start.x, dy=event.clientY-start.y;
          start=null;
          if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) this.show(this.index+(dx<0?1:-1));
        }, options);
        frame.addEventListener('pointercancel', () => { start=null; }, options);
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.comparisonBlock === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, options);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      const counter = this.querySelector('[data-comparison-count]');
      if (counter) counter.textContent = `${this.index+1} / ${this.slides.length}`;
    }
    disconnectedCallback() { this.cleanup?.abort(); }
  });
}
